import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LocationMap = () => {
  const handleGetDirections = () => {
    window.open('https://www.google.com/maps/dir/?api=1&destination=4.8517,31.5825', '_blank');
  };

  const deliveryZones = [
    {
      id: 1,
      name: 'Central Juba',
      deliveryTime: '20-30 mins',
      fee: 'Free delivery'
    },
    {
      id: 2,
      name: 'Juba East',
      deliveryTime: '30-40 mins',
      fee: '500 SSP'
    },
    {
      id: 3,
      name: 'Juba West',
      deliveryTime: '30-40 mins',
      fee: '500 SSP'
    },
    {
      id: 4,
      name: 'Juba North',
      deliveryTime: '40-50 mins',
      fee: '750 SSP'
    }
  ];

  return (
    <section className="py-8 md:py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Visit Us Or Order Delivery
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
            Find us on the map or check our delivery zones
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-lg h-full min-h-[400px] md:min-h-[500px]">
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title="Chapati Plus Location - Juba, South Sudan"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=4.8517,31.5825&z=14&output=embed"
                className="w-full h-full min-h-[400px] md:min-h-[500px]"
              />
            </div>
          </div>

          <div className="space-y-4 md:space-y-6">
            <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-lg">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="MapPin" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="font-bold text-foreground text-lg mb-1">Our Location</h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    Juba City Center, South Sudan
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="font-bold text-foreground text-lg mb-1">Business Hours</h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    Daily: 8:00 AM - 10:00 PM
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Car" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="font-bold text-foreground text-lg mb-1">Parking</h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    Free parking available on-site
                  </p>
                </div>
              </div>

              <Button
                variant="outline"
                size="lg"
                fullWidth
                iconName="Navigation"
                iconPosition="left"
                onClick={handleGetDirections}
              >
                Get Directions
              </Button>
            </div>

            <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-lg">
              <h3 className="font-bold text-foreground text-xl mb-4 flex items-center gap-2">
                <Icon name="Truck" size={24} color="var(--color-primary)" />
                Delivery Zones
              </h3>

              <div className="space-y-3">
                {deliveryZones?.map((zone) => (
                  <div
                    key={zone?.id}
                    className="p-4 bg-muted/50 rounded-lg border border-border"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="font-semibold text-foreground">{zone?.name}</h4>
                      <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
                        {zone?.fee}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Icon name="Clock" size={14} />
                      <span>{zone?.deliveryTime}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;